module.exports = __webpack_public_path__ + "img/p3-info.82460cef.jpg";